/* SteamMaster Cube, Black Friday-laag (2026). Vanilla, defer, geen dependencies.
 *
 * Countdown alleen op basis van de echte einddatum uit Theme settings (ISO met tijdzone, bijv.
 * 2026-11-30T23:59:00+01:00). Geen reset bij verversen, geen negatieve tijd:
 * - meer dan N dagen voor het einde: alleen de einddatum als tekst (geen timer);
 * - binnen N dagen: een rustige timer naast de einddatum (aria-hidden, de tekst blijft leidend);
 * - na het einde: timer weg, besparingsregels weg, melding dat de actie is afgelopen. Dit vangt pagina's
 *   uit de cache af; bij een nieuwe paginaweergave toont Liquid dan de normale versie.
 */
(function () {
  'use strict';
  var box = document.querySelector('[data-bf-end]');
  if (!box) return;
  var end = Date.parse(box.getAttribute('data-bf-end'));
  if (isNaN(end)) return;
  var days = parseInt(box.getAttribute('data-bf-days'), 10) || 0;
  var cd = box.querySelector('[data-bf-countdown]');
  var timer = null;

  function pad(n) { return n < 10 ? '0' + n : String(n); }

  function expire() {
    if (timer) clearInterval(timer);
    document.querySelectorAll('[data-bf-live]').forEach(function (el) { el.hidden = true; });
    document.querySelectorAll('[data-bf-end]').forEach(function (el) {
      var t = el.querySelector('.bf-deadline__txt');
      if (t) t.textContent = el.getAttribute('data-bf-expired') || '';
      var c = el.querySelector('[data-bf-countdown]');
      if (c) c.hidden = true;
      el.classList.add('is-expired');
    });
  }

  function tick() {
    var left = end - Date.now();
    if (left <= 0) { expire(); return; }
    if (!cd || days <= 0 || left > days * 86400000) { if (cd) cd.hidden = true; return; }
    var s = Math.floor(left / 1000);
    var d = Math.floor(s / 86400); s -= d * 86400;
    var h = Math.floor(s / 3600); s -= h * 3600;
    var m = Math.floor(s / 60); s -= m * 60;
    cd.textContent = 'nog ' + (d > 0 ? d + 'd ' : '') + pad(h) + ':' + pad(m) + ':' + pad(s);
    cd.hidden = false;
  }

  tick();
  if (end - Date.now() > 0) timer = setInterval(tick, 1000);
  // Tab op de achtergrond: bij terugkomst direct bijwerken (timers lopen dan vertraagd)
  document.addEventListener('visibilitychange', function () { if (!document.hidden) tick(); });
})();
